import { IStockFinancialsData } from "../../interfaces/StockFinancials.interface";

export const BAR_COLORS = ["#4a6784", "#faba0a"];

export const STOCK_FINANCIALS_TABS: {
  label: string;
  value: keyof IStockFinancialsData["financials"];
}[] = [
  {
    label: "Key results",
    value: "keyResults",
  },
  {
    label: "Key ratios",
    value: "keyRatios",
  },
  {
    label: "Balance sheet",
    value: "balSheet",
  },
  {
    label: "Cash flow",
    value: "cashFlow",
  },
  {
    label: "Competition",
    value: "competition",
  },
];

export const TAB_KEY_MAP: Record<
  keyof IStockFinancialsData["financials"],
  string
> = {
  keyResults: "subTabDetails",
  keyRatios: "subTabDetailsKR",
  balSheet: "subTabDetailsBS",
  cashFlow: "subTabDetailsCF",
  competition: "subTabDetailsCT",
};

export const OPTION_KEY_MAP: Record<string, string[]> = {
  Quarterly: ["revenueqly"],
  Annual: ["revenueanual"],
  Standalone: [
    "Standalonebalsheet",
    "StandalonekeyRatios",
    "Standalonecashflow",
    "Standalonecompetition",
  ],
  Consolidated: [
    "consolidatebalsheet",
    "consolidatekeyRatios",
    "consolidatecashflow",
    "consolidatecompetition",
  ],
};

export type IRangeMap = "keyResults" | "keyRatios" | "balSheet" | "cashFlow";

export const LEGEND_KEY_MAP = {
  keyResults: "legendDetails",
  keyRatios: "legendDetailsKR",
  balSheet: "legendDetailsBS",
  cashFlow: "legendDetailsCF",
};

export const SUB_TAB_KEYS = [
  "subTabTitleTextKR",
  "subTabTitleText",
  "subTabTitleTextBS",
  "subTabTitleTextCF",
  "subTabTitleTextCT",
] as const;

export const LEGEND_TITLE_KEYS = [
  "legendTitleText",
  "legendTitleTextKR",
  "legendTitleTextBS",
  "legendTitleTextCF",
] as const;

export const SUB_TAB_TITLE_KEYS = [
  "subTabTitleText",
  "SubTabTitleTextKR",
  "subTabTitleTextKR",
  "subTabTitleTextBS",
  "subTabTitleTextCF",
  "subTabTitleTextCT",
] as const;

export const TABLE_COLUMN = {
  keyResults: "tableColumnDetails",
  keyRatios: "tableColumnDetailsKR",
  balSheet: "tableColumnDetailsBS",
  cashFlow: "tableColumnDetailsCF",
  competition: "tableColumnDetailsCT",
};

export const TABLE_ROW = {
  keyResults: "tableRowDetails",
  keyRatios: "tableRowDetailsKR",
  balSheet: "tableRowDetailsBS",
  cashFlow: "tableRowDetailsCF",
  competition: "tableRowDetailsCT",
};

export const MODAL_KEY = {
  keyResults: "popUpDescription",
  keyRatios: "popUpDescriptionKR",
  balSheet: "popUpDescriptionBS",
  cashFlow: "popUpDescriptionCF",
};

export const TRADING_MALL_TABLE_VALUE_MAP = {
  Revenue: "revenue",
  "Net income": "netInc",
  "Operating expense": "opExp",
  "Net profit margin": "npm",
  "Earning per share": "eps",
  EBITDA: "ebitda",
  "Effective tax rate": "etr",
  "Total assets": "totAssets",
  "Total liabilities": "totLb",
  "Cash and short term investments": "cashStInv",
  "Total equity": "totEq",
  "Total Equity": "totEq",
  "Shares outstanding": "shOutst",
  "Price to book ratio": "ptb",
  "Return on assets (%)": "roa",
  "Return on capital": "roc",
  "Net change in cash": "netChg",
  "Cash from operations": "cashOp",
  "Cash from investing": "cashInv",
  "Cash from financing": "cashFin",
  "Free cash flow": "fcf",
  "Return on Equity (ROE)": "roeAnnual",
  "Return on Capital Employed (ROCE)": "roceAnnual",
  "Book value per share": "bvps",
  "Total debt to equity ratio": "tdtea",
  "EBITDA margin": "eam",
  "Revenue (Quarterly)": "revenueqly",
  "Revenue (Annual)": "revenueanual",
  "Standalone Balance Sheet": "Standalonebalsheet",
  "Consolidated Balance Sheet": "consolidatebalsheet",
  "Standalone Key Ratios": "StandalonekeyRatios",
  "Consolidated Key Ratios": "consolidatekeyRatios",
  "Standalone Cash Flow": "Standalonecashflow",
  "Consolidated Cash Flow": "consolidatecashflow",
  "Standalone Competition": "Standalonecompetition",
  "Consolidated Competition": "consolidatecompetition",
  Competition: "competition",
  "Revenue (Consolidated)": "revenueConsolidated",
  "Company name": "compName",
  Price: "price",
  "P/E": "pe",
  "P/B": "pb",
  "Market cap": "marketCap",
  "52 week low/high": "wkRange",
};
